import React from 'react';
import createReactClass from 'create-react-class';
import update from 'react-addons-update';

import Modal from '../../../common/components/Modal';
import NotifcationActions from '../../../common/flux/NotificationActions.js';
import EncoderPreview from './children/EncoderPreview';
import EncoderTabWrapper from './children/EncoderTabWrapper';
import RestrictedComponent from '../../../lib/components/form/RestrictedComponent';
import LowLatencyEncoderPreview from './children/LowLatencyEncoderPreview';
import schema from '../../../routes/permissions/schema';

var Encoder = createReactClass({

    getInitialState: function () {
        return {
            deleteModal: false,
            editModal: false,
            validators: [],
            edited: false,
            edits: {}
        };
    },


    /*
        State Functions
     */
    toggleDeleteModal: function () {
        this.setState({
            deleteModal: !this.state.deleteModal
        });
    },

    toggleEditModal: function () {
        if (this.state.editModal) this.revert();
        this.setState({
            editModal: !this.state.editModal
        });
    },

    revert: function () {
        this.setState(this.getInitialState());
    },

    save: function () {
        if (this.valid()) {
            // WorkspaceActions.toggleOverlay();
            this.toggleEditModal();
            this.props.actions.edit({
                encoderID: this.props.encoder.encoderID,
                simpleName: this.state.edits.simpleName,
                description: this.state.edits.description
            });
        }
    },

    valid: function () {
        var failed = [], messages = [];

        if (this.state.edited && this.state.edits.simpleName === '') {
            failed.push('simpleName');
            messages.push('Encoder Name is Required');
        }

        if (failed.length) {
            this.setState({
                validators: failed
            });

            NotifcationActions.notify({
                type: 'warning',
                messages: messages
            });

            return false;
        }

        return true;
    },

    deleteEncoder: function () {
        this.toggleDeleteModal();
        this.props.actions.delete({
            encoderID: this.props.encoder.encoderID
        });

    },

    handleChange: function (event) {
        if (!this.state.edited) {
            this.setState(function (state, props) {
                return {
                    edited: true,
                    edits: {
                        simpleName: this.props.encoder.simpleName,
                        description: this.props.encoder.description
                    }
                };
            });
        }

        var updates = {};
        updates[event.target.name] = {$set: event.target.value};

        this.setState(function (state) {
            return {
                edits: update(state.edits, updates)
            };
        });
    },



    /**
     * Render Functions
     */
    /*
        {
            "encoderID": "TVWAIR",
            "simpleName": "HD Channel AIR",
            "description": "TVWs cable channel",
            "inputURI": "rtmp://rec.tvwmedia.net/srcEncoders/TVWAIR",
            "streamName": "TVWAIR",
            "lastCommunication": "2017-01-14 00:16:39",
            "online": "1",
            "lowLatencyPreview": "https://rtcsrcmon.invintus.stream:5443/LiveApp/play.html?name=6361162879-lod2gzdh",
            "live247URI": "http://d3ktuc8v2sjk6m.cloudfront.net/livetv/ngrp:TVWAIR_all/playlist.m3u8?DVR"
        }
     */
    render: function () {

        let encoderPreview = null
        if (this.props.encoder.online) {
            encoderPreview = (this.props.encoder.lowLatencyPreview) ? 
                <LowLatencyEncoderPreview styles={{minHeight: '225px'}} classNames={'col-md-3'} encoder={this.props.encoder} /> :
                <EncoderPreview {...this.props} />
        }

        return (
            <div className="encoder">
                <div className="panel panel-default">
                    <div className="panel-heading">
                        <div className="row">
                            <div className="col-xs-6">
                                <div className="title">
                                    <div className={"status " + (this.props.encoder.online ? 'on' : 'off')} >
                                        {this.props.encoder.online ? 'Online' : 'Offline'}
                                    </div>
                                    <div className="simpleName">
                                        {this.props.encoder.simpleName}
                                    </div>
                                </div>
                            </div>
                            <div className="col-xs-6">
                                {/* {this.props.credentials.user.userRole <= 2 ? ( */}
                                    <div className="actions">
                                        <RestrictedComponent permissionCheck={schema.MANAGE_CLIENT_ENCODERS.DELETE}>
                                            <button className="btn btn-danger" onClick={this.toggleDeleteModal}><i className="fa fa-trash-can"/> Delete</button>
                                        </RestrictedComponent>
                                    </div>
                                {/* ) : null} */}
                            </div>
                        </div>
                    </div>

                    <div className="panel-body">
                        {encoderPreview}
                        <EncoderTabWrapper {...this.props}/>
                    </div>
                </div>

                {this.renderModals()}
            </div>
        );
    },

    renderModals: function () {
        if (this.state.editModal) {

            var simpleName = (this.state.edited) ? this.state.edits.simpleName : this.props.encoder.simpleName;
            var description = (this.state.edited) ? this.state.edits.description : this.props.encoder.description;

            return (<Modal
                saveAction={<button className="btn btn-primary" onClick={this.save} disabled={!this.state.edited}>
                    <i className="fa fa-save"></i> Save
                </button>}
                cancelModal={this.toggleEditModal}>
                <Modal.Header>Edit Encoder</Modal.Header>
                <Modal.Body>
                    <label>Encoder Name</label>
                    <input className="form-control" name="simpleName" value={simpleName} onChange={this.handleChange} />

                    <div style={{margin: '2rem 0'}}/>

                    <label>Encoder Description</label>
                    <textarea className="form-control" name="description" value={description} onChange={this.handleChange}></textarea>
                </Modal.Body>
                <Modal.Footer></Modal.Footer>
            </Modal>);
        } else if (this.state.deleteModal) {
            return (<Modal
                saveAction={<button className="btn btn-danger" onClick={this.deleteEncoder}>
                    <i className="fa fa-trash-can"></i> Delete
                </button>}
                cancelModal={this.toggleDeleteModal}>
                <Modal.Header>Delete Encoder</Modal.Header>
                <Modal.Body>
                    <div className="alert alert-danger">
                        <strong>Are you sure?</strong>
                        <p>When you delete an encoder please ensure to reassign automated events to another available encoder.</p>
                    </div>
                </Modal.Body>
                <Modal.Footer></Modal.Footer>
            </Modal>);
        }
    }
});

export default Encoder;
